module.exports = __webpack_public_path__ + "img/call-quality.4ca75d67.svg";